import React from 'react';
import styled from 'styled-components';
import { Select } from 'antd';

export const LinkButton = styled.a`
	display: flex;
	align-items: center;
	color: #696969;
	transition: 0.3s ease-in;
	&:hover {
		color: #88bdff !important;
	}
`;

export const ColoredBox = styled.span<{ size?: number; width?: number; height?: number }>`
	display: inline-block;
	background-color: ${({ color }) => color};
	width: ${props => props.width || props.size || 16}px;
	height: ${props => props.height || props.size || 16}px;
	border-radius: 5px;
	margin-right: 5px;
`;

export const Option = styled(Select.Option)`
	display: flex;
	align-items: center;
`;

export const ActionsContainer = styled.div`
	margin-right: 40px;

	button {
		background: none;
		border: none;
		outline: none;
		display: inline-flex;
		-webkit-box-align: center;
		align-items: center;
		-webkit-box-pack: center;
		justify-content: center;
		height: 32px;
		vertical-align: middle;
		line-height: 1;
		padding: 0px 6px;
		white-space: nowrap;
		border-radius: 3px;
		transition: all 0.1s ease 0s;
		appearance: none;
		cursor: pointer;
		user-select: none;
		font-size: 14.5px;
		background: rgb(255, 255, 255);
		color: rgb(66, 82, 110);
		font-weight: normal;

		&:not(:disabled):hover {
			background-color: rgb(235, 236, 240);
		}
		&:not(:disabled):active {
			color: #009670;
			background: #d4fff4;
		}
	}
`;
